<template lang="pug">
v-dialog(
    v-model="show",
    width="auto",
    scrollable,
    max-width="1400px"
    persistent,
    v-if="categorias"
)
    v-card.Poppins(style="max-height:700px; border-radius:10px;")
        v-card-title
            div
                .titulo Reordenar Itens
                .body-1(style="color:rgba(17, 19, 18, 0.80);") Selecione a categoria que você deseja reordenar
        v-divider
        v-card-text
            v-layout(row, wrap)
                v-flex.xs12.md3
                    .body-2 Categorias
                    v-card.my-2.mr-2(style="box-shadow:none !important;")
                        v-card.esconderScroll(style="box-shadow:none !important;max-height: 50vh;overflow-y: auto;")
                            v-list(style="padding: 0px")
                                draggable(
                                    v-model="categorias",
                                    @change="ordenarCategorias(categorias)",
                                    draggable=".categoria"
                                )
                                    .categoria.mt-1(
                                        v-for="categoria in orderBy(categorias, 'indice')",
                                        :key="categoria.id",
                                        style="background-color: rgba(199, 199, 199, 0.3);border-radius:5px;"
                                    )
                                        v-list-tile.pt-1.pb-1(
                                            style="border-radius:5px;",
                                            @click="selectCategoria(categoria), startAnimationCategoria(categoria.id)",
                                            :class="{ 'red lighten-4': !categoria.ativo, 'grey lighten-2': order.categoria == categoria && order.categoria.ativo == 1, 'circulating-border': isClickedCategoria === categoria.id }"
                                        )
                                            v-list-tile-action
                                                v-icon drag_indicator
                                            v-list-tile-content
                                                v-list-tile-title.body-1 {{ categoria.nome }}
                v-flex.xs12.md3
                    .body-2 Itens
                    v-card.my-2.mr-2(style="box-shadow:none !important;")
                        v-card.esconderScroll(style="box-shadow:none !important;max-height: 50vh;overflow-y: auto;")
                            .text-xs-center.py-3(v-if="carregandoItens")
                                v-progress-circular(indeterminate, color="primary", size="24")
                            v-list(v-if="order.categoria && !carregandoItens", style="padding: 0px")
                                draggable(
                                    v-model="order.categoria.allItens",
                                    @change="ordenarItens(order.categoria.allItens)",
                                    draggable=".item"
                                )
                                    .item.mt-1(
                                        v-for="item in orderBy(order.categoria.allItens, 'indice')",
                                        :key="item.id",
                                        style="background-color: rgba(199, 199, 199, 0.3); border-radius:5px;"
                                    )
                                        v-list-tile.pt-1.pb-1(
                                            @click="selectItem(item),startAnimationItens(item.id)",
                                            :class="{ 'red lighten-4': !(item.ativo && item.disponivel), 'grey lighten-2': order.item == item && order.item.ativo == 1 && (item.ativo && item.disponivel),'circulating-border': isClickedItens === item.id  }"
                                        )
                                            v-list-tile-action
                                                v-icon drag_indicator
                                            v-list-tile-content
                                                v-list-tile-title.body-1 {{ item.nome }}
                v-flex.xs12.md3
                    .body-2 Categorias de complementos
                    v-card.my-2.mr-2(style="box-shadow:none !important;")
                        v-card.esconderScroll(style="box-shadow:none !important;max-height: 50vh;overflow-y: auto;")
                            v-list(
                                v-if="order.item && order.item.variacoes",
                                style="padding: 0px"
                            )
                                draggable(
                                    v-model="order.item.variacoes",
                                    @change="ordenarVariacoes(order.item.variacoes)",
                                    draggable=".variacao"
                                )
                                    .variacao.mt-1(
                                        v-for="variacao in orderBy(order.item.variacoes, 'indice')",
                                        :key="variacao.id",
                                        style="background-color: rgba(199, 199, 199, 0.3); border-radius:5px;"
                                    )
                                        v-list-tile.pt-1.pb-1(
                                            @click="selectCategoriaVariacao(variacao),startAnimationVariacao(variacao.id)",
                                            :class="{'red lighten-4': !variacao.ativo,  'grey lighten-2': order.variacao == variacao  && order.variacao.ativo == 1 && variacao.ativo, 'circulating-border': isClickedVariacao === variacao.id   }",

                                        )
                                            v-list-tile-action
                                                v-icon drag_indicator
                                            v-list-tile-content
                                                v-list-tile-title.body-1 {{ variacao.nome }}
                v-flex.xs12.md3
                    .body-2 Complementos
                    v-card.my-2.mr-2(style="box-shadow:none !important;")
                        v-card.esconderScroll(style="box-shadow:none !important;max-height: 50vh;overflow-y: auto;")
                            v-list(v-if="order.variacao", style="padding: 0px")
                                draggable(
                                    v-model="order.variacao.allItens",
                                    @change="ordenarItens(order.variacao.allItens, true)",
                                    draggable=".item-variacao"
                                )
                                    .item-variacao.mt-1(
                                        v-for="item in orderBy(order.variacao.allItens, 'indice')",
                                        :key="item.id",
                                        style="background-color: rgba(199, 199, 199, 0.3); border-radius:5px;"
                                    )
                                        v-list-tile.pt-1.pb-1(
                                            @click="selectItemVariacao(item),startAnimationComplemento(item.id)",
                                            :class="{ 'red lighten-4': !(item.ativo && item.disponivel), 'grey lighten-2': order.item_variacao == item && order.item_variacao.ativo == 1 && (item.ativo && item.disponivel),'circulating-border': isClickedComplemento === item.id}"
                                        )
                                            v-list-tile-action
                                                v-icon drag_indicator
                                            v-list-tile-content
                                                v-list-tile-title.body-1 {{ item.nome }}
        v-card-actions(
                style="box-shadow: 0px -5px 27px 18px #fff; z-index:999;"
            )
            v-spacer
            v-btn(
                type="button",
                flat,
                color="gray darken-1",
                :loading="loading",
                @click="close();"
            ) Fechar
</template>

<script>

import draggable from "vuedraggable";

export default {
    $_veeValidate: {
        validator: "new",
    },
    components: {
        draggable
    },
    data: () => ({
        show: false,
        loading: false,
        order: {
            icategoria: null,
            item: null,
            variacao: null,
            item_variacao: null
        },
        categorias: null,
        carregarItensCategoria: null,
        carregandoItens: false,
        isClickedCategoria: false,
        isClickedItens: false,
        isClickedVariacao: false,
        isClickedComplemento: false,
    }),
    mounted() { },
    watch: {},
    methods: {
        open(categorias, carregarItensCategoria) {
            this.show = true;
            // this.order = {};
            this.categorias = categorias;
            this.carregarItensCategoria = carregarItensCategoria;
            this.$forceUpdate();
        },
        close(){
          this.order.icategoria = null;
          this.order.item = null;
          this.order.variacao = null;
          this.order.item_variacao = null;
          this.categorias = null;
          this.isClickedCategoria = false;
          this.isClickedItens = false;
          this.isClickedVariacao = false;
          this.isClickedComplemento = false;
          this.show = false;
        },
        async validate() {
        },
        async save(variacao) {
        },
        async getVariacoesItem(item) {
            const vm = this;
            try {
                vm.loading = true;
                const response = await vm.$axios.get("/catalogo/categoria", {
                    params: {
                        variacao: 1,
                        item_catalogo_id: item.id,
                        catalogo_id: item.catalogo_id,
                        fields: "allItens",
                    },
                });
                vm.loading = false;
                return response.data;
            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao carregar as categorias de complementos. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                vm.loading = false;
            }
        },
        orderBy(list, field) {
            return _.orderBy(list, field)
        },
        async ordenarCategorias(list) {
            const vm = this;
            try {
                list.map((categoria, indice) => {
                    categoria.indice = indice;
                });
                const response = await vm.$axios.put("/catalogo/categoria/indice", {
                    categorias: list,
                });
                vm.categorias = list;
                window.getApp.$emit("APP_DIALOG_AUX");
                this.$forceUpdate();
            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao ordenar as categorias. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
            }
        },
        async ordenarVariacoes(list) {
            const vm = this;
            try {
                list.map((variacao, indice) => {
                    variacao.indice = indice;
                });
                const response = await vm.$axios.put("/catalogo/categoria/indice", {
                    categorias: list,
                });
                vm.order.item.variacoes = list;
                window.getApp.$emit("APP_DIALOG_AUX");
                this.$forceUpdate();
            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao ordenar as categorias de complementos. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
            }
        },
        async ordenarItens(list, variacao) {
            const vm = this;
            try {
                list.map((item, indice) => {
                    item.indice = indice;
                });
                const response = await vm.$axios.put("/catalogo/item/indice", {
                    itens: list,
                });
                if (!variacao) {
                    vm.categorias.map((categoria) => {
                        if (categoria.id == list[0].categoria_id) categoria.itens = list;
                    });
                } else {
                    vm.order.variacao.allItens = list;
                }
                window.getApp.$emit("APP_DIALOG_AUX");
                this.$forceUpdate();
            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : `Ocorreu um erro ao ordenar os ${variacao ? "complementos" : "itens"
                        }. Tente novamente!`;
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
            }
        },
        async selectCategoria(categoria) {
            this.order.categoria = categoria;
            this.order.item = null;
            this.order.variacao = null;
            this.order.item_variacao = null;
            this.$forceUpdate();

            if (this.carregarItensCategoria && !categoria.completo) {
                this.carregandoItens = true;

                try {
                    await this.carregarItensCategoria(categoria);
                } finally {
                    this.carregandoItens = false;
                    this.$forceUpdate();
                }
            }
        },
        async selectItem(item) {
            const vm = this;
            vm.order.variacao = null;
            vm.order.item_variacao = null;
            vm.order.item = item;
            vm.order.item.variacoes = await vm.getVariacoesItem(item);
            this.$forceUpdate();
        },
        selectCategoriaVariacao(categoriaVariacao) {
            this.order.variacao = categoriaVariacao;
            this.order.item_variacao = null;
            this.$forceUpdate();
        },
        selectItemVariacao(itemVariacao) {
            this.order.item_variacao = itemVariacao;
            this.$forceUpdate();
        },
        startAnimationCategoria(CategoriaId) {
            this.isClickedCategoria = CategoriaId;
        },
        startAnimationItens(ItensId) {
            this.isClickedItens = ItensId;
        },
        startAnimationVariacao(VariacaoId) {
            this.isClickedVariacao = VariacaoId;
        },
        startAnimationComplemento(ComplementoId) {
            this.isClickedComplemento = ComplementoId;
        }
    }
};
</script>

<style scoped>
.circulating-border {
    background-image: linear-gradient(90deg, #1d9a5a 50%, transparent 50%),
        linear-gradient(90deg, #1d9a5a 50%, transparent 50%),
        linear-gradient(0deg, #1d9a5a 50%, transparent 50%),
        linear-gradient(0deg, #1d9a5a 50%, transparent 50%);
    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
    background-size: 15px 2px, 15px 2px, 2px 15px, 2px 15px;
    background-position: left top, right bottom, left bottom, right top;
    background-color: transparent;
    animation: border-dance 1s infinite linear;
}
@keyframes border-dance {
    0% {
        background-position: left top, right bottom, left bottom, right top;
    }
    100% {
        background-position: left 15px top, right 15px bottom, left bottom 15px,
        right top 15px;
    }
}
.titulo {
    font-family: "Poppins", "Roboto", "Helvetica" !important;
    font-size: 20px !important;
    font-weight: 500;
    line-height: 1 !important;
    letter-spacing: 0.02em !important;
}
.Poppins {
    font-family: "Poppins", "Roboto", "Helvetica" !important;
}
.esconderScroll::-webkit-scrollbar {
    display: none;
}
</style>
